import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

const BannerOne = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Handle window resize for responsive styles
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine responsive values
  const isMobile = windowWidth <= 755 && windowWidth > 550;
  const isTablet = windowWidth <= 991 && windowWidth > 756;
  const isSmallMobile = windowWidth <= 550;

  const getResponsiveValues = () => {
    if (isMobile) {
      return {
        height: '250px',
        padding: '20px',
        imageWidth: '0px',
        imageHeight: '0px',
        titleSize: '1.8rem',
        subtitleSize: '1rem',
        buttonPadding: '12px 28px',
        buttonFontSize: '1rem',
      };
    }
    if (isTablet) {
      return {
        height: '300px',
        padding: '30px',
        imageWidth: '300px',
        imageHeight: '280px',
        titleSize: '2.2rem',
        subtitleSize: '1.1rem',
        buttonPadding: '14px 32px',
        buttonFontSize: '1rem',
      };
    }
    if (isSmallMobile) {
      return {
          height: '250px',
        padding: '20px',
        imageWidth: '0px',
        imageHeight: '0px',
        titleSize: '1.8rem',
        subtitleSize: '1rem',
        buttonPadding: '12px 28px',
        buttonFontSize: '1rem',


        height: '200px',
        padding: '30px',
        imageWidth: '0px',
        imageHeight: '0px',
        titleSize: '1.5rem',
        subtitleSize: '1rem',
        buttonPadding: '12px 28px',
        buttonFontSize: '1rem',
        justifyContent:'center',
        display:'flex'
    
    };
    }
    // Desktop
    return {
      height: '350px',
      padding: '60px',
      imageWidth: '450px',
      imageHeight: '350px',
      titleSize: '3rem',
      subtitleSize: '1.2rem',
      buttonPadding: '14px 32px',
      buttonFontSize: '1.1rem',
    };
  };

  const responsive = getResponsiveValues();

  // ✅ FIX: Inject CSS to override Slick slider auto height
  useEffect(() => {
    const styleId = 'banner-slick-override';
    
    // Remove existing style if any
    const existingStyle = document.getElementById(styleId);
    if (existingStyle) {
      existingStyle.remove();
    }

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .banner-slider-wrapper .slick-slider,
      .banner-slider-wrapper .slick-list,
      .banner-slider-wrapper .slick-track {
        height: ${responsive.height} !important;
      }

      .banner-slider-wrapper .slick-slide {
        height: ${responsive.height} !important;
        overflow: hidden !important;
      }

      .banner-slider-wrapper {
        height: ${responsive.height} !important;
      }

      @media (max-width: 991px) {
        .banner-slider-wrapper .slick-slider,
        .banner-slider-wrapper .slick-list,
        .banner-slider-wrapper .slick-track {
          height: ${isTablet ? responsive.height : '100%'} !important;
        }
        .banner-slider-wrapper .slick-slide {
          height: ${isTablet ? responsive.height : '100%'} !important;
        }
      }

      @media (max-width: 767px) {
        .banner-slider-wrapper .slick-slider,
        .banner-slider-wrapper .slick-list,
        .banner-slider-wrapper .slick-track {
          height: ${isMobile ? responsive.height : '100%'} !important;
        }
        .banner-slider-wrapper .slick-slide {
          height: ${isMobile ? responsive.height : '100%'} !important;
        }
      }
         @media (max-width: 550px) {
        .banner-slider-wrapper .slick-slider,
        .banner-slider-wrapper .slick-list,
        .banner-slider-wrapper .slick-track {
          height: ${isSmallMobile ? responsive.height : '100%'} !important;
        }
        .banner-slider-wrapper .slick-slide {
          height: ${isSmallMobile ? responsive.height : '100%'} !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      const s = document.getElementById(styleId);
      if (s) s.remove();
    };
  }, [responsive.height, isMobile, isTablet]);
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  // Fetch banners from backend API
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/banner-style/`);
        
        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('Banners fetched:', data);
        
        const bannerList = Array.isArray(data) ? data : data.results || [];
        setBanners(bannerList);
        setError(null);
      } catch (err) {
        console.error('Error fetching banners:', err);
        setError(err.message);
        setBanners([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className="banner-arrow banner-arrow--next"
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className="banner-arrow banner-arrow--prev"
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dotsClass: 'slick-dots banner-dots',
  };

  // Loading state
  if (loading) {
    return (
      <div className="banner-wrapper">
        <div className="container container-lg">
          <div 
            className="banner-container"
            style={{
              height: responsive.height,
              borderRadius: '24px',
              overflow: 'hidden',
            }}
          >
            <div className="banner-slider-wrapper">
              <div 
                className="banner-slide"
                style={{
                  height: responsive.height,
                  outline: 'none',
                }}
              >
                <div 
                  className="banner-slide__inner"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: responsive.height,
                    padding: responsive.padding,
                    borderRadius: '24px',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <p style={{ color: 'white', fontSize: '18px' }}>Loading banners...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="banner-wrapper">
        <div className="container container-lg">
          <div 
            className="banner-container"
            style={{
              height: responsive.height,
              borderRadius: '24px',
              overflow: 'hidden',
            }}
          >
            <div className="banner-slider-wrapper">
              <div 
                className="banner-slide"
                style={{
                  height: responsive.height,
                  outline: 'none',
                }}
              >
                <div 
                  className="banner-slide__inner"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: responsive.height,
                    padding: responsive.padding,
                    borderRadius: '24px',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <p style={{ color: 'red', fontSize: '18px' }}>Error: {error}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // No banners available
  if (banners.length === 0) {
    return (
      <div className="banner-wrapper">
        <div className="container container-lg">
          <div 
            className="banner-container"
            style={{
              height: responsive.height,
              borderRadius: '24px',
              overflow: 'hidden',
            }}
          >
            <div className="banner-slider-wrapper">
              <div 
                className="banner-slide"
                style={{
                  height: responsive.height,
                  outline: 'none',
                }}
              >
                <div 
                  className="banner-slide__inner"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: responsive.height,
                    padding: responsive.padding,
                    borderRadius: '24px',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <p style={{ color: 'white', fontSize: '18px' }}>No banners available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="banner-wrapper">
      <div className="container container-lg">
        <div 
          className="banner-container"
          style={{
            position: 'relative',
            height: responsive.height,
            borderRadius: '24px',
            overflow: 'hidden',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          {/* Animated decorative elements - hidden on mobile */}
          {!isMobile && (
            <div className="banner-decorations">
              <div className="banner-decoration banner-decoration--1"></div>
              <div className="banner-decoration banner-decoration--2"></div>
              <div className="banner-decoration banner-decoration--3"></div>
              <div className="banner-decoration banner-decoration--4"></div>
            </div>
          )}

          <div 
            className="banner-slider-wrapper"
            style={{
              height: responsive.height,
              position: 'relative',
              zIndex: 2,
              borderRadius: '24px',
              overflow: 'hidden',
            }}
          >
            <Slider {...settings}>
              {/* Dynamically render banners from API */}
              {banners.map((banner, index) => (
                <div 
                  key={banner.banner_id || index} 
                  className="banner-slide"
                  style={{
                    height: responsive.height,
                    outline: 'none',
                  }}
                >
                  <div 
                    className="banner-slide__inner"
                    style={{
                      backgroundImage: banner.image ? `url(${banner.image})` : 'none',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      height: responsive.height,
                      padding: responsive.padding,
                      position: 'relative',
                      borderRadius: '24px',
                      overflow: 'hidden',
                      flexDirection: isMobile ? 'column' : 'row',

                    }}
                  >
                    {/* Content section (left side) */}
                    <div 
                      className="banner-content"
                      style={{
                        zIndex: 2,
                        maxWidth: isMobile ? '100%' : '500px',
                        flexShrink: 0,
                        animation: 'slideInLeft 0.8s ease-out',
                      }}
                    >
                      <h1 
                        className="banner-content__title"
                        style={{
                          fontSize: responsive.titleSize,
                          fontWeight: 700,
                          color: 'white',
                          textShadow: '2px 2px 8px rgba(0, 0, 0, 0.2)',
                          lineHeight: '1.2',
                          margin: 0,
                          marginBottom: isMobile ? '16px' : '24px',
                        }}
                      >
                        {banner.title}
                      </h1>
                      
                      <p 
                        className="banner-content__subtitle"
                        style={{
                          color: 'white',
                          fontSize: responsive.subtitleSize,
                          opacity: 0.95,
                          margin: 0,
                          marginBottom: isMobile ? '20px' : '30px',
                        }}
                      >
                        {banner.subtitle}
                      </p>
                      
                      <Link
                        to={banner.button_link || "/shop"}
                        className="banner-content__btn"
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: responsive.buttonPadding,
                          fontSize: responsive.buttonFontSize,
                          background: 'white',
                          color: '#d835ff',
                          border: 'none',
                          borderRadius: '50px',
                          fontWeight: 600,
                          textDecoration: 'none',
                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                          cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'translateY(-3px)';
                          e.target.style.boxShadow = '0 6px 25px rgba(0, 0, 0, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.2)';
                        }}
                      >
                        {banner.button_text || "Shop Now"}{" "}
                        <span 
                          className="banner-content__btn-icon"
                          style={{
                            display: 'flex',
                            fontSize: '1.25rem',
                          }}
                        >
                          <i className="ph ph-shopping-cart-simple" />
                        </span>
                      </Link>
                    </div>

                    {/* Image section (right side) - Hidden on mobile */}
                    {banner.image && responsive.imageWidth !== '0px' && (
                      <div 
                        className="banner-image"
                        style={{
                          zIndex: 2,
                          width: responsive.imageWidth,
                          height: responsive.imageHeight,
                          flexShrink: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerOne;
